import React from "react";
import classNames from "classnames";
import defaultStyle from "../row.module.scss";
import SkeletonItem from "./components/SkeletonItem";

const SkeletonRow = () => {
  return (
    <div className="overflow-x-hidden">
      <div className={classNames(defaultStyle.row)}>
        {Array.from(new Array(10)).map((item, index) => {
          return <SkeletonItem key={index} isTrending={true} />;
        })}
      </div>
    </div>
  );
};

export default SkeletonRow;
